module.exports = __webpack_public_path__ + "media/images/cards/cc-amex-9f26e9053af370c85a35dbf83d5f0ebf.svg";